import { useUserContext } from "@/components/user-context/user-context-provider";

import { LoggedOutJiraFree } from "./free/logged-out-jira-free";
import { LoggedOutJiraPremium } from "./premium/logged-out-jira-premium";
import { LoggedOutJiraStandard } from "./standard/logged-out-jira-standard";

export const LoggedOutJira = () => {
    const { edition } = useUserContext();

    if (edition === "premium") {
        return <LoggedOutJiraPremium />;
    }

    if (edition === "standard") {
        return <LoggedOutJiraStandard />;
    }

    return <LoggedOutJiraFree />;
};
